import React from 'react';
import AdminApp from '../components/admin/AdminApp';

const Admin = () => {
  return <AdminApp />;
};

export default Admin; 